export const SHARED_FILE_REQUIREMENT_EVENT = {
  UploadFile: "UploadFile",
  SubmitFileAnyway: "SubmitFileAnyway",
  DownloadAsPayee: "DownloadAsPayee",
  DownloadAsPayer: "DownloadAsPayer",
  ValidationSuccess: "ValidationSuccess",
  SubmitForReview: "SubmitForReview"
} as const;

/**
 * How many times a payee may re-upload a file against a smart (non-`None`
 * context) shared-file request before it is marked failed for client review.
 */
export const MAX_SHARED_FILE_UPLOAD_ATTEMPTS = 3;
